/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperResponsive = {
    isMobile: true,
    /**
     * Check viewport
     */
    checkViewPort() {
        this.isMobile = window.matchMedia(this.breakpoint).matches;
        this.handleOffCanvas();
    }
}

export default liveSearchHelperResponsive;
